export const skyHeightCoefficient = 0.02;
export const seaHeightCoefficient = 1 - skyHeightCoefficient;
export const groundHeightCoefficient = 0.063;
export const fishHeightCoefficient = 0.06;
export const fishWidthCoefficient = 0.1;
export const fishLeftCoefficient = 0.1;
export const targetHeightCoefficient = seaHeightCoefficient * 0.2;
export const targetWidthCoefficient = 0.1;
export const pierOnScreenSeconds = 6;
export const pierIntervalTimeSeconds = 5;
